import type React from "react";

import { snakeCaseToDisplay } from "@superblocksteam/shared";

import { useAuthorizationCheck } from "hooks/ui/rbac/useAuthorizationCheck";
import type { PermissionToCheck } from "hooks/ui/rbac/useAuthorizationCheck";
import { ForbiddenPage } from "pages/components/ForbiddenPage";
import { USER_FRIENDLY_RESOURCE_NAMES } from "pages/Permissions/constants";

export const AuthorizedPageWrapper: React.FC<{
  children: React.ReactNode;
  permissions: PermissionToCheck[];
}> = ({ children, permissions }) => {
  const isAuthorizedList = useAuthorizationCheck(permissions);

  if (!isAuthorizedList.some(Boolean)) {
    const resourceNames = permissions.map(
      (permission) =>
        USER_FRIENDLY_RESOURCE_NAMES[permission.resourceType] ??
        snakeCaseToDisplay(permission.resourceType.replaceAll(".", "_")),
    );

    const formattedResourceNames =
      resourceNames.length > 2
        ? `${resourceNames.slice(0, -1).join(", ")}, or ${resourceNames.slice(
            -1,
          )}`
        : resourceNames.join(" or ");

    return (
      <ForbiddenPage
        message={`You need the ${formattedResourceNames} read permission to use this feature. Ask your admins to update your permissions.`}
      />
    );
  }

  return <>{children}</>;
};
